<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Состав школы {{schoolid}}</h2>
          <v-spacer></v-spacer>
          <v-autocomplete
          v-model="positionid"
          :items="positions"
          item-text="name"
          item-value="positionid"
          label="класс"
          hide-details clearable style="max-width: 240px" class="mx-3"
          ></v-autocomplete>
          <v-text-field
            class="mx-5" style="max-width: 300px"
            outlined clearable hide-details dense flat label="фильтр" v-model="search"
          ></v-text-field>
          <v-dialog
            v-model="dialogImportPerson"
            scrollable persistent modal
            width="640"
            transition="dialog-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn class="mr-4" color="primary" v-on="on">Добавить в школу</v-btn>
            </template>
            <v-card>
              <v-card-title class="subtitle-1">
                Переместить в школу нового пользователя
                <v-spacer></v-spacer>
                <v-btn icon small @click="dialogImportPersonClose()"><v-icon>close</v-icon></v-btn>
              </v-card-title>
              <v-card-actions class="px-5">
                <v-text-field
                v-model="dipICardId"
                label="Номер карты"
                counter="9"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn @click="dipSearchPerson()" :disabled="!dipICardId || dipICardId.length !== 9" color="primary">Искать по карте</v-btn>
              </v-card-actions>
              <v-card-text>

                <v-text-field
                :value="dipPerson ? (dipPerson.fullname + ' ' + (dipPerson.position ? (dipPerson.position.schoolid + ' ' + dipPerson.position.name) : '')) : ''"
                label="Пользователь"
                :disabled="true"
                ></v-text-field>

                <v-alert type="error" v-if="dipPerson && dipPerson.position">
                  Чтобы добавить, нужно сначала удалить из школы {{dipPerson.position.schoolid}}
                </v-alert>

                <v-autocomplete
                :disabled="dipPerson === null"
                v-model="dipIPositionId"
                :items="positions"
                item-value="positionid"
                item-text="name"
                label="Класс/Должность"
                ></v-autocomplete>

              </v-card-text>
              <br /><br />

              <v-card-actions>
                <v-btn
                  color="primary"
                  :disabled="inaction || !dipPerson || !dipIPositionId"
                  @click="addPerson()"
                >
                  Добавить
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn text
                  @click="dialogImportPersonClose()"
                >Отмена</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="dialogChangePosition"
            scrollable persistent modal
            width="640"
            transition="dialog-transition"
          >
            <v-card>
              <v-card-title class="subtitle-1">
                Изменить должность/класс для &nbsp; <b v-if="dcpPerson">{{dcpPerson.fullname}} @ {{dcpPerson.positionname}}</b>
                <v-spacer></v-spacer>
                <v-btn icon small @click="dialogChangePositionClose()"><v-icon>close</v-icon></v-btn>
              </v-card-title>
              <v-card-text>

                <v-autocomplete
                v-model="dcpIPositionid"
                :items="positions"
                item-value="positionid"
                item-text="name"
                label="Класс/Должность"
                ></v-autocomplete>

              </v-card-text>
              <br /><br />

              <v-card-actions>
                <v-btn
                  color="primary"
                  :disabled="inaction || !dcpIPositionid"
                  @click="changePosition()"
                >
                  Установить Класс/Должность
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn text
                  @click="dialogChangePositionClose()"
                >Отмена</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </v-flex>
      <v-flex>
        <v-data-table no-data="пусто" no-data-text="пусто" no-results-text="ничего не найдено"
          :headers="headers"
          :items="filtered"
          :search="search"
          :footer-props="{
            itemsPerPageText: 'Показывать:',
            itemsPerPageOptions: [20, 40, 100, { text: 'Все', value: -1 }]
          }"
          :items-per-page.sync="itemsPerPage"
          item-key="name" :sort-by="sortby"
          dense
        >
          <template v-slot:item.locationid="{ item }">
            {{ (locations.find(x => x.locationid === item.locationid) || { name: item.locationid }).name }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn class="px-1" color="warning" x-small text @click="dcpPerson = item; dialogChangePosition = true">
              перенос
              <v-icon small>import_export</v-icon>
            </v-btn>
            <v-btn class="px-1" color="error" x-small text @click="deleteItem(item)">
              удалить
              <v-icon small>delete</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.cts="{ item }">
            {{ dateFormat(item.cts) }}
          </template>
          <template v-slot:item.arestudents="{ item }">
            <span v-if="item.arestudents === true">УЧЕНИКИ</span>
            <span v-else>СОТРУДНИКИ</span>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Persons',
  data: () => ({
    inaction: false,
    dialogImportPerson: false,
    dipPerson: null,
    dipICardId: null,
    dipIPositionId: null,
    dialogChangePosition: false,
    dcpPerson: null,
    dcpIPositionid: null,
    positions: [],
    search: '',
    sortby: 'positionname',
    headers: [
      { text: 'карта', value: 'cardid', width: '80' },
      { text: 'должность', value: 'positionname', width: '150' },
      { text: 'ФИО', value: 'fullname', width: '300' },
      { text: 'действия', value: 'action', sortable: false },
    ],
    itemsPerPage: 20,
    iname: null,
    itype: null,
    positionid: null
  }),
  methods: {
    async fetch () {
      try {
        const { positions, meta } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-positions'
        })
        this.positions = positions
        if (this.persons.length === 0) {
          await this.$store.dispatch('fetchPersons')
        }
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    dialogChangePositionClose () {
      this.dialogChangePosition = false
      this.dcpPerson = null
      this.dcpIPositionid = null
    },
    dialogImportPersonClose () {
      this.dialogImportPerson = false
      this.dipPerson = null
      this.dipICardId = null
      this.dipIPositionId = null
    },
    async addPerson () {
      try {
        if (this.inaction) return
        this.inaction = true
        const { person, meta } = await this.$store.dispatch('sioRequest', {
          topic: 'person-add-position',
          pl: {
            personid: this.dipPerson.personid,
            positionid: this.dipIPositionId
          }
        })
        await this.$store.dispatch('addPerson', {
          person: person,
          position: this.positions.filter(x => x.positionid === this.dipIPositionId)[0]
        })
        this.$store.dispatch('snack', meta)
        this.dialogImportPersonClose()
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.inaction = false
        // this.fetch()
      }
    },
    async changePosition () {
      try {
        if (this.inaction) return
        this.inaction = true
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'person-add-position',
          pl: {
            personid: this.dcpPerson.personid,
            positionid: this.dcpIPositionid
          }
        })
        this.$store.dispatch('updatePosition', {
          personid: this.dcpPerson.personid,
          position: this.positions.filter(x => x.positionid === this.dcpIPositionid)[0]
        })
        this.$store.dispatch('snack', meta)
        this.dialogChangePositionClose()
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.inaction = false
        // this.fetch()
      }
    },
    async deleteItem (item) {
      try {
        await this.$store.dispatch('confirm', `Удалить ${item.fullname} из списка школы ?`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'person-delete-from-school',
          pl: {
            personid: item.personid
          }
        })
        this.$store.dispatch('deletePerson', item.personid)
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        // this.fetch()
      }
    },
    async dipSearchPerson () {
      try {
        const { meta, person } = await this.$store.dispatch('sioRequest', {
          topic: 'search-person',
          pl: {
            cardid: this.dipICardId
          }
        })
        this.dipPerson = person
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    scopes () {
      return this.profile ? this.profile.scopes : []
    },
    isadmin () {
      return this.scopes.includes('admin')
    },
    schoolid () {
      return this.profile ? this.profile.schoolid : null
    },
    filtered () {
      if (this.positionid) return this.persons.filter(x => x.positionid === this.positionid)
      return this.persons
    },
    persons () {
      return this.$store.state.persons
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    }
  },
  mounted () {
    if (this.profile) this.fetch()
  }
}
</script>

<style lang="css">
</style>
